export default [
  {
    path: "/transactions",
    name: "transactions",
    component: () =>
      import("../views/subscriptions/transactions/TransactionView.vue"),
  },
];
